import React from "react"
import ImageGrid from "../components/ImageGrid"
import Layout from "../components/Layout"
import { useStaticQuery, graphql } from "gatsby"
import { Heading } from "rebass"

export default function Home() {
  const data = useStaticQuery(graphql`
    query allPortfolioItems {
      allContentfulPortfolioItem(filter: { unlisted: { ne: true } }) {
        edges {
          node {
            id
            slug
            title
            order
            thumbnail {
              title
              file {
                url
              }
              fixed(width: 800) {
                src
              }
            }
            content {
              title
              description
              file {
                url
              }
              fixed(height: 1500) {
                src
              }
            }
          }
        }
      }
    }
  `)
  const images = data.allContentfulPortfolioItem.edges

  const sortedImages = [...images].sort(
    (a, b) => parseFloat(a.node.order) - parseFloat(b.node.order)
  )

  return (
    <Layout
      seo={{
        title: "Greg Woodward | Photographer & Director",
        description:
          "Greg Woodward is a photographer and director creating lifestyle, sports and moving-image work for brands and editorial clients.",
        pathname: "/",
      }}
    >
      <Heading
        as="h1"
        sx={{
          position: "absolute",
          width: 1,
          height: 1,
          overflow: "hidden",
          clip: "rect(0 0 0 0)",
        }}
      >
        Greg Woodward Photography and Film
      </Heading>
      <ImageGrid {...{ images: sortedImages }} />
    </Layout>
  )
}
